export default __webpack_public_path__ + "media/images/svg/phone-icon-a938b9398dbcd614fd81d007added97a.svg";